/* eslint-disable react/require-default-props */
import React from 'react';
/**
 * PopupSection
 * A content section within a popup. May contain a PopupTitle followed by
 * action items (buttons, checkboxes, radios). Sections are scrollable when
 * popup height is constrained by viewport.
 * @version 1.0.0
 * @since 2026-03-27
 */
export function PopupSection({ children, fillHeight = false }) {
    const className = ['popup__section', fillHeight ? 'popup__section--y-fill' : ''].filter(Boolean).join(' ');
    return React.createElement("div", { className: className }, children);
}
PopupSection.displayName = 'PopupSection';
